module.exports = __webpack_public_path__ + "img/google_icon_black.ae507a64.png";